import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { User, LanguageSelector } from 'components/shared';
import * as S from './styles';
import { usePermissions, useTranslation } from 'hooks';
import { translations } from './translations';

interface IModule {
  icon: any;
  name: string;
  description: string;
  active: boolean;
  innerUrl?: string;
  url?: string;
}

const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3000/base/'
    : 'https://upl.webcol.systems/';

export const AsideMenu: React.FC = () => {
  const history = useHistory();
  const { hasAnyPermission } = usePermissions();
  const { getTranslation } = useTranslation(translations);
  const checkPermission = (typeUsers: 'All' | string[]) => {
    if (typeUsers === 'All') {
      return true;
    }

    if (hasAnyPermission(typeUsers)) {
      return true;
    } else {
      return false;
    }
  };
  const checkBlockedPermission = (typeUsers: string[]) => {
    return !hasAnyPermission(typeUsers);
  };

  const modules: IModule[] = [
    {
      icon: <S.IconControlTower />,
      name: getTranslation('controlTower'),
      description: getTranslation('descControlTower'),
      active:
        checkPermission('All') &&
        checkBlockedPermission(['Cliente', 'Transportadora']),
      innerUrl: '/control-tower',
    },
    {
      icon: <S.IconTracking />,
      name: getTranslation('Tracking'),
      description: getTranslation('descTracking'),
      active: checkPermission('All'),
      url: baseUrl + 'tracking/',
    },
    {
      icon: <S.IconSettings />,
      name: getTranslation('configurador'),
      description: getTranslation('descConfigurador'),
      active: checkPermission(['Administrador', 'Customer Service']),
      innerUrl: '/settings',
    },
  ];

  const handleNavigation = useCallback(
    (module: IModule) => {
      if (module.active) {
        if (module.innerUrl) return history.push(module.innerUrl);
        if (module.url) return window.open(module.url);
      }
    },
    [history]
  );

  return (
    <S.Container>
      <S.Content>
        <S.Logo />
        <LanguageSelector />
        <User />
        {modules.map((module) => (
          <S.ButtonModule
            active={module.active}
            onClick={() => handleNavigation(module)}
            key={module.innerUrl || module.url}
          >
            <S.ModuleTitle>
              {module.icon}
              {module.name}
            </S.ModuleTitle>
            <S.ModuleDescription>{module.description}</S.ModuleDescription>
          </S.ButtonModule>
        ))}
      </S.Content>
    </S.Container>
  );
};
